// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MZQTI","questions":"styles_questions__3j-0S","footer":"styles_footer__lSiln"};